import styled from 'styled-components';
import { api, Match } from '../api/client';
import { useAsync, Async } from '../components/Async';
import { MatchCard } from '../components/MatchCard';
import { formatDateLong, dayKey } from '../lib/format';

const DateHead = styled.h2`
  font-size: 1.15rem;
  margin: 22px 0 4px;
  display: flex;
  align-items: baseline;
  gap: 8px;
  &::before {
    content: '📅';
    font-size: 1rem;
  }
`;

const RoundTag = styled.div`
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: ${({ theme }) => theme.colors.textMuted};
  margin: 10px 0 6px;
`;

// Agrupa por día de calendario y, dentro de cada día, por ronda — preservando el orden.
function groupByDay(matches: Match[]): { day: string; iso: string | null; rounds: [string, Match[]][] }[] {
  const days: { day: string; iso: string | null; rounds: [string, Match[]][] }[] = [];
  for (const m of matches) {
    const dk = dayKey(m.kickoffUtc);
    let day = days[days.length - 1];
    if (!day || day.day !== dk) {
      day = { day: dk, iso: m.kickoffUtc, rounds: [] };
      days.push(day);
    }
    const round = m.round ?? 'Otros';
    const last = day.rounds[day.rounds.length - 1];
    if (last && last[0] === round) last[1].push(m);
    else day.rounds.push([round, [m]]);
  }
  return days;
}

export function Fixtures() {
  const state = useAsync(() => api.fixtures(), []);
  return (
    <Async state={state}>
      {(d) =>
        groupByDay(d.matches).map((day) => (
          <section key={day.day}>
            <DateHead>{formatDateLong(day.iso)}</DateHead>
            {day.rounds.map(([round, ms]) => (
              <div key={round}>
                <RoundTag>{round}</RoundTag>
                {ms.map((m) => (
                  <MatchCard key={m.id} m={m} />
                ))}
              </div>
            ))}
          </section>
        ))
      }
    </Async>
  );
}
